import { render, staticRenderFns } from "./modal-ver-progs_esam.vue?vue&type=template&id=38c8bbfc&scoped=true"
import script from "./modal-ver-progs_esam.vue?vue&type=script&lang=js"
export * from "./modal-ver-progs_esam.vue?vue&type=script&lang=js"
import style0 from "./modal-ver-progs_esam.vue?vue&type=style&index=0&id=38c8bbfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c8bbfc",
  null
  
)

export default component.exports